export const Loading = ({
  text = 'Loading, please wait...'
}) => (
  <div>{text}</div>
);